const GOOGLE_MAP_TOKEN = "AIzaSyCI1NfGNoPyn31Nx_LAkcQiCKbkKj88tI0";
export {GOOGLE_MAP_TOKEN}
